import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import { calculateMoodRetirementScores } from './objects/calculate_mood_retirement_scores';
import {doubleToStringMonthly, doubleToStringWholeDollars, standardNumberFormat} 
    from '../../objects/CommonUse/double_functions';
import ConfigFile from '../../datasets/config_file';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameData: state.gameData,
    savingsInfo: state.savingsInfo,
    timeWizardInfo: state.timeWizardInfo,
    summaryInvestment: state.summaryInvestment
    // add other Redux state slices here if needed
});


class MoodRetirementStatusModal extends Component {
            constructor(props) {
              super(props);
              this.state={
                 };   
        this.moodScore = 0;
        this.moodPercent = 0;
        this.moodRotation = 0;
        this.moodPoints = 0;
        this.retirementScore = 0;
        this.retirementPercent = 0;
        this.retirementRotation = 0;
        this.retirementPoints = 0;
        this.currentStatusComment = "";
        this.initializeMoodRetirementGraphics(); 
    }

    initializeMoodRetirementGraphics(){
        let savings = 0;
        if (this.props.savingsInfo){
            if (this.props.savingsInfo.totalSavingsAmt){
                savings = this.props.savingsInfo.totalSavingsAmt;
            }
        }
        let totalGameMonths = ConfigFile.gameStartItems.totalNbrGameMonths;
        if (this.props.timeWizardInfo.gameID  &&
            this.props.timeWizardInfo.status !== "inactive"){
                totalGameMonths = (+this.props.timeWizardInfo.gameNbrYears * 12);
        }
        let totalInvestments = 0;
        if (this.props.summaryInvestment.length > 0){
            const summaryInvestments = this.props.summaryInvestment;
            totalInvestments = summaryInvestments.find(elem => elem.investType === "all").currentValue;
        }
        let rotationObj = calculateMoodRetirementScores(this.props.gameData.currentMoodPoints,
               this.props.gameData.currentCash, savings, totalInvestments,
               this.props.gameData.assetTable,  this.props.gameData.currentGameDate);
        let moodPercent = +rotationObj.moodPercent;
        this.moodPercent = (moodPercent).toFixed(0);    
        this.moodRotation = rotationObj.moodRotation;
        this.moodPoints = this.props.gameData.currentMoodPoints;
        this.moodScore = (+rotationObj.moodScore).toFixed(0);
        let retirementPercent = +rotationObj.retirementPercent;
        this.retirementPercent = (retirementPercent).toFixed(0);
        this.retirementRotation = rotationObj.retirementRotation;
        this.retirementPoints = rotationObj.totalSavings;
        this.retirementScore = (+rotationObj.retirementScore).toFixed(0);
        this.salaryMultiplier = rotationObj.salaryMultiplier;
        this.minimumSavings = rotationObj.minimumSavings;
        this.totalRetirementAmt = rotationObj.totalRetirementAmt;
        this.totalSavings = rotationObj.totalSavings;
        this.annualSalary = rotationObj.annualSalary;
        this.combinedScore = rotationObj.combinedScore;
        this.moodRetirementScoreObj={moodScore: this.moodScore, retirementScore: this.retirementScore,
            combinedScore: this.combinedScore};
        this.totalSavings = +this.props.gameData.currentCash + +savings;
        if (this.totalSavings > this.totalRetirementSavings){
            this.currentStatusComment = " Great job!! You have saved " + 
                doubleToStringMonthly(this.totalSavings) + " which is more than the goal. " +
                "This will help you to retire on 'Easy Street'. "
        }else{
            if (+this.totalSavings === +this.totalRetirementSavings){
                this.currentStatusComment = " Great job!! You have saved " + 
                    doubleToStringMonthly(this.totalSavings) + " which is equal to the goal. " +
                    "This will help you to retire on 'Easy Street'. "
            }else{
                this.currentStatusComment = " Not there yet. You have saved " + 
                doubleToStringMonthly(this.totalSavings) + " which is less than the goal. " +
                "Keep saving as it will help you to retire on 'Easy Street'. "
            }
        }
    }

    render() {
       this.className="mood_retirement_container mood_retirement_size";
       this.arrowClass = "arrow_position";
       this.gutters = "modal_size";
       this.modalSize = "gameView-modal-size";
      
    return <>
       
      <Modal show={this.props.modalOpen}  onHide={() => this.props.onClose(this.moodRetirementScoreObj)} 
            size="lg" dialogClassName={this.modalSize} animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>
                <div >Mood and Retirement Scores</div>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <span>
                <div className="font-weight-bold text-center">Combined Score: &nbsp;&nbsp; 
                    {standardNumberFormat(this.combinedScore)}</div>
                <div className="row mt-0 py-0">
                    <div className="col-sm-6">
                        <div className="text-center font-weight-bold">Mood Point Status</div>
                        <div className="text-center font-weight-bold">
                            {this.moodScore} </div>
                  
                        <div className={this.className}>
                            <img src={'./assets/arrow.png'}
                                className={this.arrowClass}  alt={'arrow'}
                                style={{transform: `rotate(${this.moodRotation}deg)`}}/>
                        </div>
                        <div className="mt-2"></div>
                        <div>Mood points are an indication of how happy you are.  In order to
                             optimize your game status, you should work to increase both your mood
                             score and retirement score.  The best way to increase your mood score
                             is to try some of the volunteer, having fun, or vacation activities.
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="text-center font-weight-bold">Retirement Status</div>
                        <div className="text-center font-weight-bold">
                            {this.retirementScore}</div>
                            
                        <div className={this.className}>
                            <img src={'./assets/arrow.png'}
                                className={this.arrowClass} alt={'arrow'}
                                style={{transform: `rotate(${this.retirementRotation}deg)`}}/>
                        </div>
                      
                        <div className="p-0 mt-0 ml-1">
                            Your retirement savings goal is based on your annual salary. You should aim 
                            to save {this.salaryMultiplier} times your salary, with a&nbsp;
                             {doubleToStringWholeDollars(this.minimumSavings)} minimum no matter your income.
                            <ul className="ml-5">
                                <li><b>Annual salary:</b> &nbsp;{doubleToStringWholeDollars(this.annualSalary)}</li>
                                <li><b>Your goal:</b> &nbsp;{doubleToStringWholeDollars(this.totalRetirementAmt)}</li>
                                <li><b>Total savings:</b> {doubleToStringMonthly(this.totalSavings)}&nbsp;
                                 (cash, bank, retirement, and investments)
                                </li>
                            </ul>
                            {this.currentStatusComment}   
                        </div>
                    
                    </div>
                </div>
            </span>
        </Modal.Body>
        <Modal.Footer className="p-0 backgroundTopBottom">
                      <Button variant="primary"  className="mr-4" 
                            onClick={() => this.props.onClose(this.moodRetirementScoreObj)}>
                      Close
            </Button>
        </Modal.Footer>
        </Modal>
    
        </>
    }
}

export default connect(mapStateToProps)(MoodRetirementStatusModal);